import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { CustomFormContext } from '../../../formWrapper/SourSearchWrapper';
export const ResultWrapper = ({ children, onRedirect, hoverActive }) => {
    const { highlightActive } = useContext(CustomFormContext);
    return (_jsx("div", { className: `${highlightActive ? 'hover:bg-primary-100 rounded' : ''} flex cursor-pointer flex-col items-center justify-start space-x-2 p-1 text-sm sm:flex-row`, onClick: onRedirect, children: children }));
};
//# sourceMappingURL=resultWrapper.js.map